export default __webpack_public_path__ + "static/media/shark.8f1da806.png";